import React from 'react';
import { observer } from 'mobx-react';
import StarIcon from '@material-ui/icons/Star';

import AnchorLiveFeed from './AnchorLiveFeed/AnchorLiveFeed';
import GroupShowStore from '../../store/GroupShowStore';
import Adds from '../Adds/Adds';
import LiveBroadcastStore from '../../store/LiveBroadcastStore';
import '../../pages/AnchorPage/css/Anchor.old.css';


@observer
class OldBanner extends React.Component {
  render() {
    const {
      anchor,
      anchorVideoUrl,
      user,
      chatService,
      chatServiceTempted,
      guestUser,
      anchorId,
      openContextualOverlay,
      extractIdFromSlug,
      slug,
      history,
      onNetworkError,
      isBanned,
      showFanZone,
      isSpotlighing,
      spotlighedAnchorUsername,
      spotlighedAnchorNickname,
      fetchStreamDetails,
    } = this.props;

    const isWhitelisted = user ? user.features.includes('ANCHOR_PORTAL') : false;
    const isAnchor = user && user.user ? user.user.account.anchor : false;
    const { anchorSubscriptions } = user.authenticated && user.user.account;
    const isSubscribed = user.authenticated && anchorSubscriptions && anchorSubscriptions.find((sub) => sub.subCategory === extractIdFromSlug());
    const onProbation = parseInt(anchorId, 10) === 120;
    const { isInGroupShow } = GroupShowStore;
    const { streamStarted } = LiveBroadcastStore;
    const isPastAnchor = !anchor.guest && !anchor.current;
    const canSubscribeToAnchor = !isPastAnchor && ((!user.authenticated && showFanZone) ||
      (!isAnchor && !onProbation && !isSubscribed && isWhitelisted && showFanZone));

    const AnchorSubscribeButton = () => {
      if (!canSubscribeToAnchor) {
        return null;
      }

      return (
        <div className="anchor-subscribe">
          <button
            className="subscribe-to-anchor-cta"
            onClick={() => openContextualOverlay(true)}
          >
            <StarIcon />
            <span>Become A Fan</span>
          </button>
        </div>
      );
    };

    const shouldRenderLiveFeed = streamStarted && ((anchorVideoUrl && isWhitelisted) || isInGroupShow);

    return (
      <div className="masthead anchor-banner-container">
        {shouldRenderLiveFeed &&
          <AnchorLiveFeed
            anchor={anchor}
            anchorId={anchorId}
            anchorVideoUrl={anchorVideoUrl}
            background={anchor.promopic}
            canSubscribeToAnchor={canSubscribeToAnchor}
            chatService={chatService}
            chatServiceTempted={chatServiceTempted}
            fetchStreamDetails={fetchStreamDetails}
            guestUser={guestUser}
            history={history}
            isAlreadySubscribedToAnchor={isSubscribed}
            isAnchor={isAnchor}
            isBanned={isBanned}
            isInGroupShow={isInGroupShow}
            isSpotlighing={isSpotlighing}
            isWhitelisted={isWhitelisted}
            openContextualOverlay={openContextualOverlay}
            slug={slug}
            spotlighedAnchorNickname={spotlighedAnchorNickname}
            spotlighedAnchorUsername={spotlighedAnchorUsername}
            user={user}
            onNetworkError={onNetworkError}
          />
        }
        <div className="container">
          <div className="anchor-banner">
            <div
              className="anchor-banner-image"
              style={{ backgroundImage: `url(${anchor.image ? anchor.image : anchor.biopic})` }}
            />
            <div className="anchor-banner-title">
              <div className="anchor-banner-name">
                {anchor.name}
              </div>
              <AnchorSubscribeButton />
            </div>
            <Adds isAnchorPageAd={true} />
          </div>
        </div>
      </div>
    );
  }
}

export default OldBanner;
